module.exports = __webpack_public_path__ + "static/media/service-svg1.40a20ccc.svg";